import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const statEmployeeByDutyModule: LocaleModule = {
  name: "statEmployeeByDuty",
  messages: { en: en, it: it },
};
